import React from "react";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { MergeToastContainer } from "@merge-api/merge-javascript-shared";

import GlobalStyle from "./styles/globalStyle";
import AppRouter from "./router/AppRouter";

import {
  QBO_BANK_FEED_OAUTH_AUTHORIZE_PATH,
  QBO_BANK_FEED_OAUTH_CALLBACK_PATH,
  OAUTH_CALLBACK_PATH,
} from "./router/RouterUtils";
import OAuthRedirectScreen from "./components/pages/authentication/oauth/OAuthRedirectScreen";
import QBOBankFeedAuthorizeScreen from "./components/pages/authentication/oauth/QBOBankFeedAuthorizeScreen";
import QBOBankFeedCallbackScreen from "./components/pages/authentication/oauth/QBOBankFeedCallbackScreen";

const App = () => {
  return (
    <Router>
      <GlobalStyle />
      <Switch>
        <Route exact path={QBO_BANK_FEED_OAUTH_AUTHORIZE_PATH}>
          <QBOBankFeedAuthorizeScreen />
        </Route>
        <Route exact path={QBO_BANK_FEED_OAUTH_CALLBACK_PATH}>
          <QBOBankFeedCallbackScreen />
        </Route>
        <Route exact path={OAUTH_CALLBACK_PATH}>
          <OAuthRedirectScreen />
        </Route>
        <Route>
          <AppRouter />
        </Route>
      </Switch>
      <MergeToastContainer />
    </Router>
  );
};

export default App;
